module.exports = __webpack_public_path__ + "logic-min.png?4f864436d4d77bee609794f7025b3f91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logic-min.png
// module id = 38
// module chunks = 0